import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import AppErrorBoundary from '../AppErrorBoundary/AppErrorBoundary';
import Loader from '../Loader/Loader';


const ForgotPassword = lazy(() => import('../../pages/ForgotPassword'));

const App = () => {
  const routes = (
    <Switch>
      <Route exact path="/" component={ForgotPassword} />
      <Route exact path="/:token" component={ForgotPassword} />
      <Route component={ForgotPassword} />
    </Switch>
  );

  return (
    <AppErrorBoundary>
      <Suspense fallback={<Loader />}>
        <Router basename="/">
          <Suspense fallback={<Loader />}>
            {routes}
          </Suspense>
        </Router>
      </Suspense>
    </AppErrorBoundary>
  );
};

export default App;
